import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginComponent} from './login/login.component';
import {RemindPasswordComponent} from './remind-password/remind-password.component';
import {ResetPasswordComponent} from './reset-password/reset-password.component';
import {CodeComponent} from './code/code.component';
import {PasswordExpiredComponent} from './password-expired/password-expired.component';
import {AccessDeniedComponent} from './access-denied/access-denied.component';
import {LinkViewComponent} from './link-view/link-view.component';
import {UserLoggedRedirectGuard} from "./admin/user-logged-redirect.guard";
import {LogoutCallbackComponent} from "./logout-callback/logout-callback.component";
import {AboutComponent} from "./about/about.component";
import {ExternalLoginSuccessComponent} from "./external-login-success/external-login-success.component";

export const routes: Routes = [
  { path: '', component: LoginComponent },

  { path: 'boslogin', children:
  [
    {path: '', component: LoginComponent, pathMatch: 'full', canActivate: [UserLoggedRedirectGuard]},
    {path: 'logout', redirectTo: '/boslogin?logout=true'},
    {path: 'progress', redirectTo: '/boslogin?progress=true'},
    {path: 'logout/expired', redirectTo: '/boslogin?logout=true&message=SEC_SESSION_EXPIRED'},
    {path: 'remind', component: RemindPasswordComponent},
    {path: 'callback', component: LogoutCallbackComponent},
  ]},
  { path: 'resetform/:login/:token/:domain', component: ResetPasswordComponent},
  { path: 'resetform/:login/:token/', redirectTo: 'resetform/:login/:token/default'},
  { path: 'codeinput', component: CodeComponent},
  { path: 'resetform/:login/:token', component: ResetPasswordComponent},
  { path: 'passwordexpired', component: PasswordExpiredComponent},
  { path: 'view/:id', component: LinkViewComponent},
  { path: 'accessDenied', component: AccessDeniedComponent},
  { path: 'about', component: AboutComponent},
  { path: 'externallogin', component: ExternalLoginSuccessComponent},
  { path: '**', redirectTo: ''},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
